module.exports = __webpack_public_path__ + "img/WX20241119-095114@2x.92b69ae9.png";